module.exports = __webpack_public_path__ + "img/中国荔枝产业大会1.f4d031bf.png";